export const CARD_LIST = [
    {
        title: 'Team Workspaces',
        description:
            'Team-wide visibility into shared quotes and orders to collaborate and monitor status.',
        icon: 'teamWorkspaceImg',
        link: 'https://help.fictiv.com/en/articles/6496968-what-are-team-workspaces?_ga=2.62398892.186608905.1665460656-1454890269.1665460656',
    },
    {
        title: 'Preferred pricing - 5% discount',
        description:
            'Exclusive savings on applicable orders (subject to terms)',
        icon: 'preferredPricingImg',
        link: 'https://help.fictiv.com/en/articles/6541365-what-is-preferred-pricing',
    },
    {
        title: 'Lead-Time Optimizer',
        description:
            'Automated guidance on how to adjust order requirements to hit a target delivery date.',
        icon: 'ltoImg',
        link: 'https://help.fictiv.com/en/articles/6526968-how-to-use-the-lead-time-optimizer?_ga=2.62398892.186608905.1665460656-1454890269.1665460656',
    },
]
